import { getAccounts } from "@/api/authNew";
import { useQuery } from "@tanstack/react-query";

export const accountsQueryKeys = {
  list: "accounts-list",
};

export function useAccounts() {
  return useQuery({
    queryKey: [accountsQueryKeys.list],
    queryFn: getAccounts,
  });
}
